import React from 'react';

// Keeps an unexpected rendering error from blanking the whole page.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error('Unexpected rendering error:', error);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="form-container" role="alert">
        <h2 className="form-title">Something went wrong</h2>
        <p className="intro-text">
          The dashboard hit an unexpected problem while displaying this page. Reloading usually fixes it.
        </p>
        <button type="button" style={{ width: '100%' }} onClick={() => window.location.reload()}>
          Reload page
        </button>
      </div>
    );
  }
}
